import * as React from "react";
import { Route, Switch } from "react-router-dom";

import HomeHighlightsPage from "../../components/homeHighlightsPage";
import HomeNewsPage from "../../components/homeNewsPage";
import HomePage from "../../components/homePage";

export const ROUTES = {
  HOME: "/",
  HIGHLIGHTS: "/highlights",
  NEWS: "/articles",
};

export const Routes = React.memo(() => {
  return (
    <Switch>
      <Route path={`${ROUTES.NEWS}`}>
        <HomeNewsPage />
      </Route>
      <Route path={`${ROUTES.HIGHLIGHTS}`}>
        <HomeHighlightsPage />
      </Route>
      <Route path={`${ROUTES.HOME}`} exact>
        <HomePage />
      </Route>
    </Switch>
  );
});
